export enum DeckBoard {
	COMMANDER = "commander",
	COMPANION = "companion",
	MAIN = "main",
	SIDE = "side",
	MAYBE = "maybe",
	SIGNATURE_SPELLS = "signature_spells",
	ATTRACTIONS = "attractions",
	STICKERS = "stickers",
	CONTRAPTIONS = "contraptions",
	PLANES = "planes",
	SCHEMES = "schemes",
}

export const deckBoards = [
	DeckBoard.COMMANDER,
	DeckBoard.COMPANION,
	DeckBoard.MAIN,
	DeckBoard.SIDE,
	DeckBoard.MAYBE,
	DeckBoard.SIGNATURE_SPELLS,
	DeckBoard.ATTRACTIONS,
	DeckBoard.STICKERS,
	DeckBoard.CONTRAPTIONS,
	DeckBoard.PLANES,
	DeckBoard.SCHEMES,
] as const;

export const deckBoardLabels = {
	[DeckBoard.COMMANDER]: "Commander",
	[DeckBoard.COMPANION]: "Companion",
	[DeckBoard.MAIN]: "Mainboard",
	[DeckBoard.SIDE]: "Sideboard",
	[DeckBoard.MAYBE]: "Considering",
	[DeckBoard.SIGNATURE_SPELLS]: "Signature Spells",
	[DeckBoard.ATTRACTIONS]: "Attractions",
	[DeckBoard.STICKERS]: "Stickers",
	[DeckBoard.CONTRAPTIONS]: "Contraptions",
	[DeckBoard.PLANES]: "Planar deck",
	[DeckBoard.SCHEMES]: "Schemes",
};
